module.exports = __webpack_public_path__ + "media/images/emblems/Embd_Wappen-bd10fd96ef8e278ed443e132e3376158.png";